import { ReducedOffshoreReport } from '@navstation-portal/reporting/data-model/offshore-reports';
import { EntityId } from '@navstation-portal/shared/data-model/common';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const offshoreReportsEvents = eventGroup({
  source: 'OffshoreReportsStore',
  events: {
    fetchReports: type<string>(),
    fetchReportsSuccess: type<ReducedOffshoreReport[]>(),
    fetchReportsFailed: type<Error>(),
    openReport: type<{ vesselId: string; reportId: EntityId }>(),
    reset: type<void>(),
  },
});
